<div class="add-group">
  <!-- Template headers -->
  <div class="group-header mb-0">
    <div class="ui-g-12 flex-between-center py-0">
      <div class="flex-start-center width-100p">
        <i class="far fa-users-class header-icon"></i>
        <div class="group-description width-100p p-relative">
          <app-input id="group-name" type="text" placeholder="Group name*" styleClassInput="width-100p"
            theme="secondary" [autoFocus]="true" [value]="group.title" [maxLength]="100" [fontSize]="14"
            (appChange)="handleChange('title',$event)">
          </app-input>
        </div>
        <i id="group-close-dialog" class="far fa-times pointer dialog-close" (click)="closeDialog(null)"></i>
      </div>
    </div>
  </div>
  <!-- Template headers End-->

  <!-- Template body starts -->
  <div class="ui-g group-body pt-0 pb-0">
    <div class="ui-g-12 inputs-column-spacing group-inner-body" style="overflow: initial !important;">
      <h4 class="font-14 font-gray-45 font-bold mt-10 mb-0">Step 1/2: Select group type</h4>

      <!-- SMS -->
      <div class="input-basic-info-wrapper ui-g-12 p-0 mt-20">
        <div class="input-default-style mb-0">
          <div class="ui-g-12 p-0 input-control-container">
            <div class="ui-g-6 py-0 pl-0 pr-15 flex-start-center">
              <div class="icon flex-center-start">
                <i class="far fa-clipboard-user height-icon font-14"></i>
              </div>

              <div class="width-100p group-ddl">
                <app-dropdown id="group-markup" listId="group-markup-list" field="title" scrollHeight="180px"
                  theme="light" styleClass="markup-dropdown-wrapper" styleClassSelectedView="pl-0"
                  styleClassValue="pl-0" styleClassDropdownList="markup-dropdown-list-wrapper" label="Type*"
                  placeholder="Type*" styleClassValue="text-truncate" itemWidth="394px" theme="light" position="top"
                  [floatingLabel]="true" [isDropdownIconVisible]="true" [fontSize]="14" [fullyControlled]="true"
                  [truncateString]="true" [options]="groupType" [hasHoverEffect]="false" [clickOnSelectedValue]="true"
                  [hasBorderBottomOnActive]="true" [hasBgOnActive]="false" [hasHoverEffect]="false" [value]="group.type"
                  [hasCustomItemTemplate]="true" [isInline]="true" (appSelect)="handleChange('type', $event)">

                  <ng-template let-item appTemplate="item">
                    <div class="ui-g p-0">
                      <div class="ui-g-12 p-0 flex-start-start">
                        <div class="flex-column font-12">
                          <span class="font-14 font-secondary-900 font-600">
                            {{ item?.title }}
                          </span>

                          <span class="font-12 font-secondary-700">
                            <span>
                              {{ item?.description }}
                            </span>
                          </span>
                        </div>
                      </div>
                    </div>
                  </ng-template>
                </app-dropdown>
              </div>
            </div>

            <div class="ui-g-6 py-0 pr-0 pl-15 flex-start-center">
              <div class="icon flex-center-start">
                <i class="far fa-stream height-icon font-14"></i>
              </div>

              <div class="width-100p">
                <app-input id="group-total-price" type="text" placeholder="Description" theme="light" maxLength="1000"
                  [fontSize]="14" [errorMessage]="" [floatingLabel]="true" [value]="group.description"
                  (appChange)="handleChange('description',$event)">
                </app-input>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Template body ends -->

  <!-- Start Add Parts Footer -->
  <div class="ui-g-12 flex-between-center dialog-footer group-footer py-3">
    <div class="group-add-dialog-footer d-flex justify-content-end width-100p">
      <button id="group-cancel-btn" class="btn btn-white btn-border pointer btn-submit mr-2"
        (click)="closeDialog(null)">Cancel</button>
      <button id="group-save-btn" class="btn btn-primary btn-submit" style="transition: 0.3s ease all;"
        [disabled]="isProcessing || isLoading || !isValid" (click)="navigateToNext()">
        <span [ngClass]="{'pr-2': isProcessing || isLoading}">Next</span>
        <i *ngIf="isProcessing || isLoading" class="far fa-spinner rotate"></i>
      </button>
    </div>
  </div>
  <!-- End Add Parts Footer -->
</div>
